/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import toast from "react-hot-toast";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import GoalTrackingModal from "../../../../components/modelpopup/GoalTrackingModal";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import ProtectedButton from "../../../../Routes/Approuter/ProtectedButton";
import {
  formatDateInTimezone,
  getCurrentDate,
} from "./../../../../utils/formatDateInTimezone";
import { companyID } from "../../../../auth";
import GoalActivationModal from "../../../../components/modelpopup/GoalActivationModal";
import GoalCycleModal from "../../../../components/modelpopup/GoalCycleModal";
import api from "../../../../api/axios";
import { deleteGoalCycleConfig } from "../../../../services/goalService";

const GoalSetting = () => {
  const [paginationValue, setPaginationValue] = useState(5);
  const date = new Date();
  const current_year = date.getFullYear();
  const [show, setShow] = useState(false);
  const [handleData, setHandleData] = useState({});
  const [activationState, setActivationState] = useState(null);
  const [activationType, setActivationType] = useState(null);
  const emp_id = localStorage.getItem("employeeID");

  // New state for CRUD operations
  const [showGoalCycleModal, setShowGoalCycleModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteData, setDeleteData] = useState(null);

  const activationHandler = (record, state, type) => {
    setShow(true);
    setHandleData(record);
    setActivationState(state);
    setActivationType(type);
  };

  const handleClose = () => {
    setShow(false);
    setHandleData({});
    setActivationState(null);
  };

  const handleOpenCreateModal = () => {
    setEditData(null);
    setShowGoalCycleModal(true);
  };

  const handleOpenEditModal = (record) => {
    setEditData(record);
    setShowGoalCycleModal(true);
  };

  const handleCloseGoalCycleModal = () => {
    setShowGoalCycleModal(false);
    setEditData(null);
  };

  const handleOpenDeleteModal = (record) => {
    setDeleteData(record);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteData(null);
  };

  const handleDelete = async () => {
    try {
      await deleteGoalCycleConfig(deleteData.id);
      toast.success("Goal cycle deleted successfully");
      fetchConfiguration();
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Error deleting goal cycle:", error);
      toast.error("Failed to delete goal cycle");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "cycle_name",
    },
    {
      title: "Goal Applicability",
      dataIndex: "department_names",
      render: (text, record) => (
        <div
          className={`badge ${
            record?.department_names ? "badge-success" : "badge-info"
          }`}
          title={`Applicable for ${
            record?.department_names ? record?.department_names : "all department"
          }`}
        >
          {record?.department_names ?? "Default"}
        </div>
      ),
    },
    {
      title: "Goal cycle",
      dataIndex: "goal_cycle",
      render: (text, record) => (
        <>
          {`${formatDateInTimezone(record?.cycle_start_date) ?? "-"}`} to{" "}
          {`${formatDateInTimezone(record?.cycle_end_date) ?? "-"}`}
        </>
      ),
    },
    {
      title: "Goal Creation Deadline ",
      dataIndex: "goal_creation_deadline",
      render: (text, record) =>
        record?.goal_creation_deadline
          ? formatDateInTimezone(record?.goal_creation_deadline)
          : "-",
    },
    {
      title: "Performance Review Deadline",
      dataIndex: "self_review_deadline",
      render: (text, record) => (
        <>
          {record?.self_review_deadline
            ? formatDateInTimezone(record?.self_review_deadline)
            : "-"}
        </>
      ),
    },
    {
      title: "Appraisal deadline",
      dataIndex: "appraisal_deadline",
      render: (text, record) =>
        record?.appraisal_deadline
          ? formatDateInTimezone(record?.appraisal_deadline)
          : "-",
    },
    {
      title: "Goal Creation Status",
      dataIndex: "goal_creation_status",
      render: (text, record) => (
        <>
          {text == 0 ? (
            <span
              className="bg-danger badge"
              style={{ cursor: "pointer" }}
              onClick={() =>
                activationHandler(record, true, "Goal Creation Status")
              }
            >
              InActive
            </span>
          ) : (
            <span
              className="bg-success badge"
              style={{ cursor: "pointer" }}
              onClick={() =>
                activationHandler(record, false, "Goal Creation Status")
              }
            >
              Active
            </span>
          )}
        </>
      ),
    },
    {
      title: "Performnace Review Status",
      dataIndex: "self_review_status",
      render: (text, record) => (
        <>
          {text == 0 ? (
            <span
              className="bg-danger badge"
              style={{ cursor: "pointer" }}
              onClick={() =>
                activationHandler(record, true, "Performnace Review Status")
              }
            >
              InActive
            </span>
          ) : (
            <span
              className="bg-success badge"
              style={{ cursor: "pointer" }}
              onClick={() =>
                activationHandler(record, false, "Performnace Review Status")
              }
            >
              Active
            </span>
          )}
        </>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => handleOpenEditModal(record)}
            title="Edit"
          >
            <i className="fa fa-edit" />
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleOpenDeleteModal(record)}
            title="Delete"
          >
            <i className="fa fa-trash" />
          </button>
        </div>
      ),
    },
  ];

  const [goalConfigurationData, setGoalConfihurationData] = useState([]);
  const company_id = companyID();

  const fetchConfiguration = async () => {
    try {
      const response = await api.get(
        `api/goal/companies/${company_id}/goal-cycle-configs`
      );
      if (response?.data?.result?.length > 0) {
        setGoalConfihurationData(response?.data?.result);
      }
    } catch (error) {
      console.error(error);
      setGoalConfihurationData([]);
    }
  };

  useEffect(() => {
    fetchConfiguration();
  }, []);

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={`Goals Setting For ${new Date().getFullYear()}`}
            title="Dashboard"
            subtitle="Goal Setting"
          />
          {/* Add New Button */}
          <div className="row mb-3">
            <div className="col-auto ms-auto">
              <button
                className="btn btn-primary"
                onClick={handleOpenCreateModal}
              >
                <i className="fa fa-plus" /> Add New
              </button>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  className="table-striped"
                  columns={columns}
                  dataSource={
                    goalConfigurationData.length > 0 && goalConfigurationData
                  }
                  pagination={{ pageSize: paginationValue }}
                  scroll={{ x: true }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      <GoalTrackingModal />
      <GoalActivationModal
        fetchConfiguration={fetchConfiguration}
        handleClose={handleClose}
        activationState={activationState}
        handleData={handleData}
        show={show}
        goalConfigurationData={goalConfigurationData}
        activationType={activationType}
      />
      <GoalCycleModal
        show={showGoalCycleModal}
        handleClose={handleCloseGoalCycleModal}
        editData={editData}
        fetchConfiguration={fetchConfiguration}
      />
      {showDeleteModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="form-header">
                  <h3>Delete Goal Cycle</h3>
                  <p>Are you sure you want to delete this Goal Cycle?</p>
                </div>
                <div className="modal-btn delete-action">
                  <div className="row">
                    <div className="col-6">
                      <button
                        className="btn btn-primary continue-btn w-100"
                        onClick={handleDelete}
                      >
                        Delete
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="btn btn-primary cancel-btn w-100"
                        onClick={handleCloseDeleteModal}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GoalSetting;
